import React, { Component } from 'react';

export default class PlayerProgress extends Component{
    state = {
        
    }
    render(){
        return (
            <div className="playerProgress">
                <h1>Ship Terminal</h1>
            </div>
        )
    }
}